import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Tabs, Tab, Box, Typography, Container } from '@material-ui/core';
import { Helmet } from "react-helmet";
import { useSelector } from 'react-redux';
import HelpPersonal from './HelpPersonal';
import HelpBusiness from './HelpBusiness';

const useStyles = makeStyles((theme) => ({
    pageHeader: {
        textAlign: 'center',
        padding: '3rem 0',
        backgroundColor: '#f5f5f5',
        marginBottom: '3rem',
    },
    heading: {
        fontSize: '3rem',
        fontWeight: 700,
        color: '#26344a',
        margin: 0,
    },
    helpPage: {
        padding: '2rem 0',
        marginBottom: '4rem',
    },
    tabs: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        marginBottom: '2rem',
    },
    tab: {
        fontSize: '1.6rem',
        fontWeight: 600,
        textTransform: 'none',
        minHeight: '60px',
        '&.Mui-selected': {
            backgroundColor: '#3273dc',
            color: '#fff',
        },
    },
    tabPanel: {
        padding: '2rem 0',
    },
    // Shared styles for help page components
    helpImage: {
        textAlign: 'center',
        margin: '2rem 0',
    },
    helpImageStyle: {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '2px solid #e0e0e0',
    },
    helpLine: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginBottom: '1rem',
        color: '#4a4a4a',
    },
    helpDivider: {
        margin: '2rem 0',
        backgroundColor: '#e0e0e0',
    },
    helpInfoText: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginBottom: '1rem',
        color: '#3273dc',
        fontStyle: 'italic',
    },
    helpLink: {
        color: '#3273dc',
        textDecoration: 'none',
        fontWeight: 600,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    helpWarningText: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginTop: '1rem',
        color: '#ff3860',
        fontWeight: 600,
    },
    helpParagraph: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginBottom: '1rem',
        color: '#4a4a4a',
    },
}));

// Export the styles so child components can use them
export const helpStyles = {
    helpImage: {
        textAlign: 'center',
        margin: '2rem 0',
    },
    helpImageStyle: {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        border: '2px solid #e0e0e0',
    },
    helpLine: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginBottom: '1rem',
        color: '#4a4a4a',
    },
    helpDivider: {
        margin: '2rem 0',
        backgroundColor: '#e0e0e0',
    },
    helpInfoText: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginBottom: '1rem',
        color: '#3273dc',
        fontStyle: 'italic',
    },
    helpLink: {
        color: '#3273dc',
        textDecoration: 'none',
        fontWeight: 600,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    helpWarningText: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginTop: '1rem',
        color: '#ff3860',
        fontWeight: 600,
    },
    helpParagraph: {
        fontSize: '1.6rem',
        lineHeight: 1.6,
        marginBottom: '1rem',
        color: '#4a4a4a',
    },
};

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`help-tabpanel-${index}`}
            aria-labelledby={`help-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const Help = () => {
    const classes = useStyles();
    const currentUser = useSelector(state => state.user.currentUser);
    const defaultIndex = currentUser && currentUser.profile.user_type == "Business" ? 1 : 0;
    const [value, setValue] = React.useState(defaultIndex);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <Helmet>
                <title>ご利用方法</title>
                <meta name="description" content="ニュージーワークスの使い方を求職者用アカウント・企業・雇用主用アカウントに分けて解説しています。" />
            </Helmet>

            <Box className={classes.pageHeader}>
                <Typography variant="h1" className={classes.heading}>
                    ご利用方法
                </Typography>
            </Box>

            <Container className={classes.helpPage}>
                <Box className={classes.tabs}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="help tabs"
                        variant="fullWidth"
                    >
                        <Tab
                            label="仕事をお探し中の方"
                            className={classes.tab}
                        />
                        <Tab
                            label="求人広告を投稿したい方"
                            className={classes.tab}
                        />
                    </Tabs>
                </Box>

                <TabPanel value={value} index={0} className={classes.tabPanel}>
                    <HelpPersonal />
                </TabPanel>
                <TabPanel value={value} index={1} className={classes.tabPanel}>
                    <HelpBusiness />
                </TabPanel>
            </Container>
        </div>
    )
}

export default Help